import { OperatingUnit } from '../../models/operating-unit.model';

export function parseOperatingUnit(value: unknown, businessUnit?: string): OperatingUnit {
  if (!value) {
    return null;
  }

  let parsedValue = value;
  if (typeof value === 'string') {
    try {
      parsedValue = JSON.parse(value);
    } catch (error) {
      parsedValue = value;
    }
  }

  if (parsedValue && typeof parsedValue === 'object') {
    return parsedValue as OperatingUnit;
  }

  if (typeof parsedValue === 'string') {
    const code = parsedValue.trim();
    // Saved businessUnit is display text ("50226 - DE Florida Power Delivery"); keep only the BU code
    const businessUnitCode = (businessUnit || '').split(' - ')[0].trim();
    return {
      OPERATING_UNIT: code,
      DESCR: code,
      BUSINESS_UNIT: businessUnitCode,
      BU_DESCR: '',
    };
  }

  return null;
}